export default __webpack_public_path__ + "static/media/ap-screens.9760ddaa.jpg";